(function () {

    'use strict';

    angular.module('Services').factory('ScheduledPickUpsTableService', ScheduledPickUpsTableService);

    function ScheduledPickUpsTableService(TableLiteFactory, ClientService, $q, Carrier, $uibModal, ConfirmationModalFactory) {
        return function () {
            const deleteConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.deleteRecord.MESSAGE',
                code: 'messages.warning.deleteRecord.CODE',
            });

            const frequency = {
                MONDAY: false,
                TUESDAY: false,
                WEDNESDAY: false,
                THURSDAY: false,
                FRIDAY: false,
                SATURDAY: false,
                SUNDAY: false
            };
            function showAddSchedModal(sched = {}) {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'r-c-p-modal',
                    templateUrl: '/templates/pages/client/location/ScheduledPickupModal.html',
                    controller: 'ScheduledPickupModalController',
                    controllerAs: 'vm',
                    size: 'md',
                    appendTo: $('body'),
                    resolve: {
                        schedule: function () {
                            return angular.copy(angular.extend(sched, { enableOfficeEditing: true }))
                        }
                    }
                });

                modalInstance.result.then(function (data) {
                    tableActions.sendRequest({});
                }, function () {
                    tableActions.sendRequest({});
                });
            }
            const scheduledPickUpsTable = {
                tableName: 'ManifestOfficeSchedule',
                frequency: {
                    MONDAY: 'Mon',
                    TUESDAY: 'Tues',
                    WEDNESDAY: 'Wed',
                    THURSDAY: 'Thu',
                    FRIDAY: 'Fri'
                },
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'ADD PICKUP SCHEDULE',
                        onClick: function () {
                            showAddSchedModal()
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    tableMinHeight: '0px',
                },
                headers: [{
                    label: 'Company',
                    viewName: 'companyName',
                    filterName: 'company.name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },
                //{
                //     label: 'Contact Person',
                //     viewName: 'contactPerson',
                //     filterName: 'contactPerson',
                //     filter: {
                //         type: 'text',
                //         placeholder: 'Search',
                //         onSubmit: function (header) {
                //             tableActions.sendRequest(tableActions.evaluateFilter(header));
                //         }
                //     },
                //     // uncomment this one after the sort filter is fixed 
                //     // headerFn: function(){
                //     //     tableActions.sort(this.filterName);
                //     // }
                // },
                {
                    label: 'Email',
                    viewName: 'email',
                    filterName: 'email',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    // uncomment this one after the sort filter is fixed 
                    // headerFn: function(){
                    //     tableActions.sort(this.filterName);
                    // }
                }, {
                    label: 'Office',
                    viewName: 'officeName',
                    filterName: 'office.name',
                    filter: {
                        type: 'text',
                        class: 'filter-company',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Carrier Profile',
                    viewName: 'carrierProfileName',
                    filterName: 'carrierProfileId',
                    sortName: 'serviceProfile.carrierProfile.name',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        model: '',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.carrierProfilesCompact((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, { size: 30, name: model });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.viewName);
                    },
                }, {
                    label: 'Service Profile',
                    viewName: 'serviceProfileName',
                    filterName: 'serviceProfileId',//to fix
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'displayName',
                        filterBy: 'id',
                        items: [], //List of items shown in dropdown
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.serviceProfilesCompact((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, { size: 30, name: model, carrierProfileId: tableActions.activeFilters.carrierProfileId });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Pick-up Time',
                    viewName: 'pickupTimeFormat',
                    /*filterName: 'todayTotalJobs',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }*/
                }, {
                    label: 'Frequency',
                    viewName: 'frequencyFormat',
                    /*filterName: 'zones',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }*/
                }, {
                    label: 'Cutoff',
                    viewName: 'cutoffFormatted',
                    /*filterName: 'zones',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }*/
                }, {
                    label: 'action',
                    viewName: 'action',
                    /*filterName: 'zones',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }*/
                }],
                rowOnClick: sched => showAddSchedModal(sched),
                resetFilters: () => {
                    tableActions.resetFilters();
                },
                onInit: function () {
                    tableActions.sendRequest({});
                },
                data: []
            };
            const tableActions = new TableLiteFactory(scheduledPickUpsTable,
                {
                    serviceCallback: ClientService.Location.getPickupSchedules,
                    callbackFormat: ['ids', 'success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    paramId: '',
                    defaultFilters: angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'id,asc'
                    })
                }
            );

            function buildTableData(data) {
                if (!data)
                    return tableData;
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    const { pickupTime } = item;
                    const pickupTimeHr = Math.floor(pickupTime || 0);
                    const pickupTimeMin = Math.round(((pickupTime || 0) - pickupTimeHr) * 60);
                    const hourFormatted = pickupTimeHr < 10 ? `0${pickupTimeHr}` : pickupTimeHr;
                    const minFormatted = pickupTimeMin < 10 ? `0${pickupTimeMin}` : pickupTimeMin;
                    const frequencyValues = angular.copy(frequency);

                    item.companyName = item.company.name;
                    item.contactPerson = `${item.company.name}`;
                    item.email = item.company.email || 'N/A';

                    item.carrierProfileName = angular.getObjVal(item, 'serviceProfile.carrierProfile.name') || 'N/A';
                    item.serviceProfileName = angular.getObjVal(item, 'serviceProfile.name') || 'N/A';
                    item.pickupTimeFormat = `${hourFormatted}:${minFormatted}`;
                    (item.pickupDays || []).forEach(fre => {
                        frequencyValues[fre] = true;
                    });
                    item.frequencyFormat = {
                        url: '/templates/pages/client/location/frequencyTableBody.html',
                        frequencyValues
                    };
                    item.cutoffFormatted = `${item.cutoff || 0} hrs before pickup`;
                    item.officeName = angular.getObjVal(item, 'office.name') || 'N/A';
                    item.office = angular.getObjVal(item, 'office');
                    item.action = {
                        type: 'button',
                        buttons: [{
                            text: 'DELETE',
                            class: 'btn btn-danger btn-quirk',
                            action: function (row) {
                                deleteConfirmation.getInstance().result.then((cond) => {
                                    if (cond)
                                        ClientService.Location.deletePickupSchedule(row.id, () => tableActions.sendRequest({}),
                                            err => toastr.error('Unable to delete schedule', err.message));
                                });
                            }
                        }]
                    };
                    scheduledPickUpsTable.data.push(item);
                });
            }
            this.tableData = scheduledPickUpsTable;
        };
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/ScheduledPickUpsTableService.js